module.exports = __webpack_public_path__ + "static/index/img/baikal-201.6f8c2650.jpg";